/**
 * countryRulesService
 */
angular.module('app-ui-country-rules').service(
    'countryRulesRepository',
    [
        'pipeRatApiRepositoryService',
        function (
            pipeRatApiRepositoryService
        ) {
            return pipeRatApiRepositoryService.getNewRepository(
                '/api/resource/country-rules',
                'countryRulesRepository'
            );
        },
    ]
);
